<div
  class="flex-wrap gap-1 items-center justify-center text-wrap"
  [ngClass]="{
    'inline-flex': inline,
    flex: !inline,
    'justify-center': center,
    'justify-start': !center,
  }"
>
  @if (prefix !== "") {
    <span
      [ngClass]="{
        'text-sm': size === 'small',
        'text-lg': size === 'large',
        'text-xs': size === 'xsmall',
      }"
      [innerHTML]="prefix | safe: 'html'"
    ></span>
  }
  @for (sentence of filterSentences; track sentence; let i = $index) {
    <span
      class="inline-flex items-center px-2 py-1 rounded-md font-medium bg-blue-100 text-blue-800"
      [ngClass]="{
        'mt-2': !noOffset,
        'text-sm': size === 'small',
        'text-lg': size === 'large',
        'text-xs': size === 'xsmall',
      }"
    >
      {{ sentence }}
    </span>
    <!-- inline-flex
    items-center
    px-2.5
    py-0.5
    rounded-md
    text-sm
    font-medium
    bg-gray-100
    text-gray-800
    -->
    @if (filterSentences.length > 1 && i !== filterSentences.length - 1) {
      <span
        class="h-full text-center"
        [ngClass]="{
          'mt-2': !noOffset,
          'text-sm': size === 'small',
          'text-lg': size === 'large',
          'text-xs': size === 'xsmall',
        }"
        >and</span
      >
    }
  }
  <ng-content />
</div>
